/**
 * Eine aufgelöste Aktion — dasselbe wie `LegalAction` in der Engine, als Datenformat.
 *
 * **Die Felder sind absichtlich eins zu eins übernommen** und nicht zu einem bequemeren
 * Format umbenannt. Eine Umbenennung wäre eine Übersetzungsschicht, die bei jeder
 * Engine-Änderung nachgezogen werden muss — und wenn sie es nicht wird, trägt die Nachricht
 * ein Feld, das es nicht mehr gibt. Ein Test schickt deshalb eine **echt berechnete** Aktion
 * durch dieses Schema: läuft die Engine weg, schlägt er an.
 *
 * `victimTo` fehlt, wenn die gestoßene Figur über den Rand geht (`capturedByPush`). Als
 * `optional` und nicht `nullable`, weil `JSON.stringify` ein `undefined`-Feld ohnehin
 * weglässt — damit braucht es für den Umlauf keinen eigenen Serialisierer.
 *
 * **Eigenes Modul seit Zyklus 11g**, weil es jetzt zwei Leser gibt: die öffentliche Preview
 * über WebSocket (§29, §36) und die Debug-Ansicht über HTTP, die dem Admin die Aktionen des
 * Spielers am Zug auflistet — ohne sie hätte „Spieler simulieren" keine `actionId`. Ein Import
 * aus `ws-messages.ts` ginge nicht: das Modul importiert selbst aus `rest-dtos.ts`, und daraus
 * würde ein Zyklus.
 */
import { z } from 'zod';
const hexSchema = z.strictObject({ q: z.number().int(), r: z.number().int() });
const playerIdSchema = z.string().min(1);
const actionIdSchema = z.string().min(1);
const actionBase = {
    id: actionIdSchema,
    player: playerIdSchema,
    piece: z.string().min(1),
};
export const legalActionSchema = z.discriminatedUnion('type', [
    z.strictObject({
        ...actionBase,
        type: z.literal('MOVE'),
        from: hexSchema,
        to: hexSchema,
    }),
    z.strictObject({
        ...actionBase,
        type: z.literal('CAPTURE'),
        from: hexSchema,
        /** Feld des Gegners — und das Feld, auf dem die Figur danach steht (§21). */
        to: hexSchema,
        victim: z.string().min(1),
    }),
    z.strictObject({
        ...actionBase,
        type: z.literal('PUSH'),
        from: hexSchema,
        to: hexSchema,
        victim: z.string().min(1),
        victimAt: hexSchema,
        /** Endposition der gestoßenen Figur. Fehlt beim Stoß über den Rand. */
        victimTo: hexSchema.optional(),
        capturedByPush: z.boolean(),
        /** Feld des Stoßers danach — bei `pusherAdvance: 0` sein Ausgangsfeld. */
        pusherTo: hexSchema,
    }),
    z.strictObject({
        ...actionBase,
        type: z.literal('RESPAWN'),
        /** Kein `from`: die Figur kommt aus dem Respawn-Pool, nicht von einem Feld (§22). */
        to: hexSchema,
    }),
]);
//# sourceMappingURL=legal-actions.js.map